module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightdrizzle-5eed28f3e99389b6c35c6bba888edeb2.svg";